export default __webpack_public_path__ + "static/DSC_0150-069b9920ff4c6c0fe7de563e81680403.jpg";